export default __webpack_public_path__ + "static/media/TelaAmazonia-V-Color.977e9a8e.png";